/** A job's own page gives each tab its own route, `/jobs/:id/<tab>` (`recordTabRoutes`). */
export const JOB_TABS = ['details', 'cargo', 'terms', 'attachments', 'readiness', 'trips', 'history'] as const;
export type JobTab = (typeof JOB_TABS)[number];

export const JOB_TAB_LABELS: Record<JobTab, string> = {
  details: 'Details',
  cargo: 'Cargo',
  terms: 'Commercial terms',
  attachments: 'Attachments',
  readiness: 'Readiness',
  trips: 'Trips',
  history: 'History',
};

export function jobPath(id: string): string {
  return `/jobs/${id}`;
}

export function jobTabPath(id: string, tab: JobTab): string {
  return `${jobPath(id)}/${tab}`;
}
